import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../../user.interface';
import { ApiResponse, ApiService } from '../api/api.service';

@Injectable()
export class UserService {
    constructor(private apiService: ApiService) {}

    public registerUser(user: User): Promise<User> {
        return this.apiService.postCall('user/register', user);
    }

    public changeUserSettings(emailNotifications: boolean): Observable<ApiResponse<User['settings']>> {
        return this.apiService.patchCall$<User['settings']>('auth/me/settings/notifications', {
            settings: { emailNotifications },
        });
    }
}
